import { DateTime } from 'luxon'

export function getSeasonalPeriodRange(
  seasonalStart: string | null | undefined,
  seasonalEnd: string | null | undefined
): { end: string; start: string } | null {
  if (!seasonalStart || !seasonalEnd) {
    return null
  }

  const seasonalStartDateTime = DateTime.fromFormat(seasonalStart, 'dd-LL-yyyy')
  const seasonalEndDateTime = DateTime.fromFormat(seasonalEnd, 'dd-LL-yyyy')
  if (!seasonalStartDateTime.isValid || !seasonalEndDateTime.isValid) {
    return null
  }

  const today = DateTime.now()
  const formattedStart =
    seasonalStartDateTime > today
      ? seasonalStartDateTime.toFormat('yyyy-LL-dd')
      : today.toFormat('yyyy-LL-dd')

  const formattedEnd = seasonalEndDateTime.toFormat('yyyy-LL-dd')

  return { end: formattedEnd, start: formattedStart }
}

export function isPeriodMatchingSeasonalRange(
  period: { end: string; start: string } | null,
  seasonalStart: string | null | undefined,
  seasonalEnd: string | null | undefined
): boolean {
  const seasonalRange = getSeasonalPeriodRange(seasonalStart, seasonalEnd)
  if (!seasonalRange || !period?.start || !period?.end) {
    return false
  }

  // On the last bookable day of the season the remaining range is 1 day.
  // A daily selection must not be treated as a seasonal booking.
  if (
    period.start === period.end ||
    seasonalRange.start === seasonalRange.end
  ) {
    return false
  }

  return (
    period.start === seasonalRange.start && period.end === seasonalRange.end
  )
}
